import type { ReactNode } from 'react';

import {
  Tooltip as ShadcnTooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/shadcn/ui/tooltip';

type TooltipProps = {
  children: ReactNode;
  content: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  delayDuration?: number;
  disableHoverableContent?: boolean;
  disabled?: boolean;
};

export function Tooltip({
  children,
  content,
  side = 'top',
  align = 'center',
  delayDuration = 0,
  disableHoverableContent = false,
  disabled = false,
}: TooltipProps) {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <ShadcnTooltip
      delayDuration={delayDuration}
      disableHoverableContent={disableHoverableContent}
    >
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} align={align}>
        {content}
      </TooltipContent>
    </ShadcnTooltip>
  );
}
